<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../component/common/Value/ArraySlotView.svelte";
    import ImageView from "../../component/common/Image/ImageView.svelte";


    let spaces = null;

    onMount(() => {
        loadData();
    });

    let isLoading = false;

    function loadData() {
        const paramMap = {};
        paramMap['include_icon_s3_url'] = undefined;

        const url = UrlUtil.createApiUrl("space", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            spaces = body['spaces'];


        });
    }


</script>


<div class="space-list-view">

    <LoadingContentView isLoading={isLoading} isCenter={true}>
        <ArraySlotView array={spaces} dataName="閲覧できるスペース">
            <div class="space-list-area">
                {#each spaces as space}
                    <a href={`/#/space/${space.unique_id}`}>
                        <div class="space">
                            <div class="name">
                                {#if space.icon_s3_url != null}
                                    <ImageView src={space.icon_s3_url} alt={space.name}/>
                                {:else}
                                    { space.name }
                                {/if}

                            </div>
                        </div>
                    </a>
                {/each}
            </div>
        </ArraySlotView>

    </LoadingContentView>

</div>
<style lang="scss">
    .space-list-view {
        text-align: center;

        .space-list-area {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 32px;

            .space {
                border-radius: 8px;
                padding: 24px;
                word-break: keep-all;
                width: 200px;

                background-color: #f6f6f6;
                filter: drop-shadow(2px 4px 6px #0002);
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition-duration: 0.5s;

                .name {
                    transition-duration: 0.5s;
                    height: 100%;
                    width: 100%;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .resource-count {
                    opacity: 0.5;
                    font-size: 0.5em;
                    margin-top: 16px;
                }

                &:hover {
                    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.5);
                    transform: translateY(-5px);

                    .name {
                        transform: scale(1.5);
                    }
                }

                &:active {
                    transform-duration: 0.25s;
                    box-shadow: 0 0 0 0;
                    transform: translateY(0px);
                }


            }
        }

    }
</style>